<template>
	<span>
		<span v-if="display">
			<v-text-field :hint="hint" :value="display(model)" :disabled="true" :label="label"></v-text-field>
		</span>
		<span :title="model" v-if="!display">
			<v-textarea
				:placeholder="placeholder"
				v-model="model"
				@input="update()"
				:disabled="inputDisabled"
				:label="label"
				:rules="computedRules"
				:hint="hint"
				persistent-hint
			/>
		</span>
	</span>
</template>

<script>
import BaseInput from './baseInput'
export default {
	extends: BaseInput,
	props: ['display', 'placeholder'],
}
</script>



// WEBPACK FOOTER //
// src/baseComponents/inputs/textAreaInput.vue